import { render, staticRenderFns } from "./CallNumber.vue?vue&type=template&id=7557eae7&scoped=true&"
import script from "./CallNumber.vue?vue&type=script&lang=js&"
export * from "./CallNumber.vue?vue&type=script&lang=js&"
import style0 from "./CallNumber.vue?vue&type=style&index=0&id=7557eae7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7557eae7",
  null
  
)

export default component.exports